import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import { Accordion, AccordionGroup } from 'components/Accordion';
import { DescriptionItem } from 'components/DescriptionList';

import './index.css';

const ListSkeleton = () => {
  return (
    <div className={'fr-skeleton'}>
      <AccordionGroup>
        <Accordion>
          <IonGrid>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Period'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Status'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Affiliate'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Applications'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Network'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Platform'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Campaigns'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Amount'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Type'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Reason'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'} />
              <IonCol size={'6'}>
                <DescriptionItem label={'Approvers'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Last Updated By'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Created By'} type={'skeleton'} />
              </IonCol>
            </IonRow>
          </IonGrid>
        </Accordion>
        <Accordion title={'Statistics'} />
      </AccordionGroup>
    </div>
  );
};
export default ListSkeleton;
